<template>
    <transition name="fade" v-if="seen" appear>
        <div>
            <slot></slot>

            <a href class="block my-8 text-center py-2 px-4 rounded-md border border-primary font-bold" :class="this.nextSubstep ? 'bg-white text-primary' : 'bg-primary text-white'" @click.prevent="next($event)">
                {{ nextText || 'Ok, next'}}
            </a>
        </div>
    </transition>
</template>

<script>
export default {
    props: {
        name: {
            type: String,
            required: true,
        },
        open: {
            type: Boolean,
            required: false,
        },
        nextText: {
            type: String,
            required: false,
        },
        nextSubstep: {
            type: String,
            required: false,
        },
    },
    data() {
        return {
            seen: this.open || false,
        };
    },
    mounted() {
        Event.$on('substep-show', name => {
            if (name === this.name) this.seen = true;
        });
    },
    methods: {
        next($event) {
            if (this.nextSubstep) {
                $event.target.style.display = 'none';
                Event.$emit('substep-show', this.nextSubstep);
            }

            this.$emit('completed');
        }
    }
}
</script>

<style>
.fade-enter-active {
  transition: all .3s ease;
}
.fade-leave-active {
  transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.fade-enter-to, .fade-leave {
  opacity: 1;
}
.fade-enter, .fade-leave-to {
   opacity: 0;
}
</style>